import ProductsShowcase from './productsGridShowcase';
import { getSymbol } from '../../../services/currency';

/**
 * Class used as a controller for individual grid showcase items.
 */
export default class ProductsItem {
    productId: string;
    pricingOptions: any;
    fromTextOne: string;
    fromTextTwo: string;
    prices: {}[];
    showItem: boolean = false;
    parentCtrl: ProductsShowcase;
    modal: boolean = false;

    constructor() {
        /// Default values if prices are not available.
        this.prices = [
            { text: this.fromTextOne, amount: -1 },
            { text: this.fromTextTwo, amount: -1 }
        ];
    }

    /**
     * Method used to attach a handler to a promise in the parent controller. This promise is resolved once the api
     * response is received.
     */
    onItemInitialized() {
        const teaserPricesPromise = this.parentCtrl.getTeaserPrices();

        if (!teaserPricesPromise || !this.productId) {
            return;
        }

        let tagKey = '';
        if (this.pricingOptions) {
            for (const i in this.pricingOptions) {
                if (this.pricingOptions.hasOwnProperty(i)) {
                    tagKey += `:${i}:${this.pricingOptions[i]}`;
                }
            }
        }
        const priceIndex = `${this.productId}${tagKey}`;
        teaserPricesPromise.then(data => {
            if (!data) {
                return;
            }
            const item = data[priceIndex];
            if (item && item.Prices.length) {
                this.prices = item.Prices.map(price => ({
                    text: price.Type,
                    currency: getSymbol(price.Currency),
                    amount: price.Price
                }));
            }
        });
    };
}

angular
    .module('TR')
    .directive('productsGridItem', (): ng.IDirective => ({
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {},
        bindToController: {
            productId: '@',
            pricingOptions: '=',
            fromTextOne: '@',
            fromTextTwo: '@'
        },
        controller: ProductsItem,
        controllerAs: 'pi',
        require: '^productsGridShowcase',
        link(scope, el, attr, ctrl:ProductsShowcase, transclude) {
            transclude(scope, (clone:any) => {
                el.append(clone);
            });
            scope.pi.parentCtrl = ctrl;
            scope.pi.onItemInitialized();
        }
    }));
